<div class="reports-page">

  <div class="page-header">

    <div>

      <div class="breadcrumb">
        HR Management / Reports
      </div>

      <h1>
        Reports
      </h1>

      <p>
        Generate and download HR reports and analytics.
      </p>

    </div>

    <button
      mat-raised-button
      color="primary"
      (click)="generateReport()">

      <mat-icon>
        add
      </mat-icon>

      Generate Report

    </button>

  </div>


  <mat-card class="reports-card">

    <div class="filters">

      <mat-form-field appearance="outline" class="search-field">

        <mat-label>
          Search reports
        </mat-label>

        <input
          matInput
          [(ngModel)]="searchText"
          (ngModelChange)="filterReports()"
          placeholder="Report title or category">

        <mat-icon matSuffix>
          search
        </mat-icon>

      </mat-form-field>

    </div>

    <mat-divider></mat-divider>

    <div class="reports-grid">

      <mat-card class="report-card" *ngFor="let report of filteredReports">

        <div class="report-icon">
          <mat-icon>
            {{ report.type === 'PDF' ? 'picture_as_pdf' : 'table_chart' }}
          </mat-icon>
        </div>

        <div class="report-info">

          <h3>
            {{ report.title }}
          </h3>

          <span class="report-category">
            {{ report.category }}
          </span>

          <div class="report-meta">
            <span>
              <mat-icon>calendar_today</mat-icon>
              {{ report.generatedDate }}
            </span>

            <span>
              <mat-icon>insert_drive_file</mat-icon>
              {{ report.size }}
            </span>

            <span class="type-badge">
              {{ report.type }}
            </span>
          </div>

        </div>

        <button
          mat-stroked-button
          color="primary"
          class="download-btn"
          (click)="downloadReport(report)">

          <mat-icon>download</mat-icon>

        </button>

      </mat-card>

      <div class="no-data" *ngIf="filteredReports.length === 0">

        <mat-icon>
          description
        </mat-icon>

        <h3>
          No Reports Found
        </h3>

      </div>

    </div>

  </mat-card>

</div>
